<template>
  <div>
    <h1 >Registrar Concesionario</h1>
      <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <!--<button @click="sendWelcomeEmail">sendEmail</button>-->
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="addConcesionario()" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Nombre del concesionario">
                <a-input
                  placeholder="Nombre del concesionario"
                  v-model="$v.getConcesionarioId.name.$model"
                />
                <small
                  class="text-danger"
                  v-if="!$v.getConcesionarioId.name.required"
                  >Campo requerido. No debe estar vacío.</small
                >
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Correo electrónico">
                <a-input placeholder="Correo electrónico" v-model="$v.getConcesionarioId.email.$model" />
                <small class="text-danger" v-if="!$v.getConcesionarioId.email.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.getConcesionarioId.email.email">El correo electrónico no es válido, no debe contener espacios. Vuelve a intentarlo.</small><br>
                <small class="text-danger" v-if="!validateRegisteredEmail($v.getConcesionarioId.email.$model)">Este correo electrónico ya ha sido registrado previamente. Intenta con uno diferente.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de teléfono">
                <a-input
                  placeholder="Número de teléfono"
                  v-model="$v.getConcesionarioId.phoneNumber.$model"
                />
                <small class="text-danger" v-if="!$v.getConcesionarioId.phoneNumber.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.getConcesionarioId.phoneNumber.phoneNumber">El número de teléfono no es válido, no debe contener espacios. Vuelve a intentarlo.</small><br>
                <small class="text-danger" v-if="!validateRegisteredPhone($v.getConcesionarioId.phoneNumber.$model)">Este número de telefono ya ha sido registrado previamente. Intenta con uno diferente.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="RFC">
                <a-input placeholder="RFC" v-model="$v.getConcesionarioId.rfc.$model" />
                <small class="text-danger" v-if="!$v.getConcesionarioId.rfc.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.getConcesionarioId.rfc.rfc">El RFC no es válido, no debe contener espacios y tiene que estar en letras mayúsculas. Vuelve a intentarlo.</small><br>
                <small class="text-danger" v-if="!validateRegisteredRFC($v.getConcesionarioId.rfc.$model)">Este RFC ya ha sido registrado previamente. Intenta con uno diferente.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Estado">
                <v-select :options="Object.values(estados)" @input="handleEstadoChange" @select="handleEstadoChange" v-model="$v.getConcesionarioId.address.state.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <!--<a-input
                  placeholder="Estado"
                  v-model="$v.getConcesionarioId.address.state.$model"/>-->
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.state.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Municipio">
                <v-select :options="Object.keys(municipios)" @input="handleMunicipioChange" @select="handleMunicipioChange" v-model="$v.getConcesionarioId.address.city.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <!--<a-input
                  placeholder="Municipio"
                  v-model="$v.getConcesionarioId.address.city.$model"
                />-->
                <small class="text-danger" v-if="!$v.getConcesionarioId.address.city.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Código Postal">
                <v-select :options="Object.keys(codigos)" @input="handleCodigoChange" @select="handleCodigoChange" v-model="$v.getConcesionarioId.address.postalCode.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <!--<a-input
                  placeholder="Código Postal"
                  v-model="$v.getConcesionarioId.address.postalCode.$model"/>-->
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.postalCode.required">Campo requerido. No debe estar vacío.</small><br>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.postalCode.numeric">Ingresa un código postal válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Colonia">
                <v-select :options="Object.values(colonias)" v-model="$v.getConcesionarioId.address.suburb.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <!--<a-input
                  placeholder="Colonia"
                  v-model="$v.getConcesionarioId.address.suburb.$model"/>-->
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.suburb.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número exterior">
                <a-input
                  placeholder="Número exterior"
                  v-model="$v.getConcesionarioId.address.extNumber.$model"/>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.extNumber.required">Campo requerido. No debe estar vacío.</small><br>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.extNumber.alphaNum">Ingresa un número exterior válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número interior">
                <a-input
                  placeholder="Número interior"
                  v-model="$v.getConcesionarioId.address.intNumber.$model"/>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.intNumber.alphaNum">Ingresa un número interior válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Calle">
                <a-input
                  placeholder="Calle"
                  v-model="$v.getConcesionarioId.address.street.$model"/>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.street.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Preferente">
                <a-checkbox v-model="preferential">
                  Preferente
                </a-checkbox>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!(validateRegisteredEmail($v.getConcesionarioId.email.$model) && validateRegisteredPhone($v.getConcesionarioId.phoneNumber.$model) && validateRegisteredRFC($v.getConcesionarioId.rfc.$model) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { sendEmail } from '../../../ses/sendEmail.js'
// import { encrypt } from '@/config/headers'
import { required, helpers, alphaNum, numeric } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
const phoneNumber = helpers.regex('phone', /^[0-9]{10}$/)
const rfc = helpers.regex('rfc', /^([A-ZÑ&]{3,4})+?(?:-?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))+?(?:-?)?([A-Z\d]{2})([A-Z\d])$/)
const email = helpers.regex('email', /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/)
const GET_CONCESIONARIOS = gql`
  query getConcesionarios{
    getConcesionarios{
      id
      rfc
      email
      phoneNumber
      preferential
    }
  }
`
export default {
  data: function () {
    return {
      disabledButton: false,
      error: null,
      id: this.$route.params.id,
      form: this.$form.createForm(this),
      preferential: false,
      pref: 0,
      getConcesionarioId: {
        name: '',
        email: '',
        phoneNumber: '',
        rfc: '',
        address: {
          city: '',
          extNumber: '',
          intNumber: '',
          postalCode: '',
          state: '',
          suburb: '',
          street: '',
        },
        tripsAvailable: 0,
      },
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredRFC: {},
      registeredPhone: {},
      registeredEmail: {},
      estados: ['Ciudad de México', 'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
        'Coahuila de Zaragoza', 'Colima', 'Chiapas', 'Chihuahua', 'Durango', 'Guanajuato', 'Guerrero',
        'Hidalgo', 'Jalisco', 'México', 'Michoacán de Ocampo', 'Morelos', 'Nayarit', 'Nuevo León',
        'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
        'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz de Ignacio de la Llave', 'Yucatán', 'Zacatecas'],
      municipios: [],
      codigos: [],
      colonias: [],
      data: {},
    }
  },
  /*
  apollo: {
    getConcesionarioId: {
      query: gql`
        query getConcesionarioId($id: Int!) {
          getConcesionarioId(id: $id) {
            id
            name
            email
            phoneNumber
            rfc
            address {
              id
              city
              extNumber
              intNumber
              postalCode
              state
              suburb
              street
            }
            tripsAvailable
          }
        }`,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
      error (erro) {
        console.log(erro)
      },
      variables() {
        return {
          id: this.id ? parseInt(this.id) : 1,
        }
      },
      skip() {
        return this.skipQuery
      },
      result({ data }) {
        this.getConcesionarioId.phoneNumber = data.getConcesionarioId.phoneNumber.replace('+52', '')
        const emailEdition = this.getConcesionarioId.email
        const rfcEdition = this.getConcesionarioId.rfc
        const phoneEdition = this.getConcesionarioId.phoneNumber
        this.$apollo.query({ query: GET_CONCESIONARIOS  })
          .then(({ data }) => {
            data.getConcesionarios.forEach(concesionario => {
              this.registeredRFC[concesionario.rfc] = 1
              this.registeredPhone[concesionario.phoneNumber] = 1
              this.registeredEmail[concesionario.email] = 1
            })
            delete this.registeredEmail[emailEdition]
            delete this.registeredPhone['+52' + phoneEdition]
            delete this.registeredRFC[rfcEdition]
            // console.log(this.registeredRFC)
            // console.log(this.registeredPhone)
            // console.log(this.registeredEmail)
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
  },
  */
  methods: {
    /*
    send() {
      sendEmail('carlos.loera@g-tech.io')
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.log(error)
        })
    }, */
    sendWelcomeEmail() {
      sendEmail('carlos.loera@g-tech.io', 'carlos')
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    async addConcesionario() {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      console.log(this.preferential, 'pref')
      if (this.preferential === true) {
        this.pref = 1
      } else {
        this.pref = 0
      }
      await this.$apollo.mutate({
        mutation: gql`mutation addConcesionario($name: String, $email: String, $phoneNumber: String, $rfc: String, $tripsAvailable: Int, $city: String, $extNumber: String, $intNumber: String, $postalCode: String, $state: String, $suburb: String, $street: String, $preferential: Int) {
        addConcesionario(concesionario: {
        name: $name
        email: $email
        phoneNumber: $phoneNumber
        rfc: $rfc
        tripsAvailable: $tripsAvailable
        preferential: $preferential
        address:{
          city: $city
          extNumber: $extNumber
          intNumber: $intNumber
          postalCode: $postalCode
          state: $state
          suburb: $suburb
          street: $street
        }
      }){
        name
        email
        phoneNumber
        rfc
        tripsAvailable
        preferential
        address{
          city
          extNumber
          intNumber
          postalCode
          state
          suburb
          street
        }
      }
      }`,
        context: headers(),
        variables: {
          name: this.getConcesionarioId.name,
          email: this.getConcesionarioId.email.trim(),
          phoneNumber: '+52' + this.getConcesionarioId.phoneNumber,
          rfc: this.getConcesionarioId.rfc.trim(),
          city: this.getConcesionarioId.address.city,
          extNumber: this.getConcesionarioId.address.extNumber,
          intNumber: this.getConcesionarioId.address.intNumber,
          postalCode: this.getConcesionarioId.address.postalCode,
          state: this.getConcesionarioId.address.state,
          suburb: this.getConcesionarioId.address.suburb,
          street: this.getConcesionarioId.address.street,
          preferential: this.pref,
          tripsAvailable: 0, // parseInt(this.getConcesionarioId.tripsAvailable),
        },
      })
        .then(res => {
          this.$router.push('/concesionarios/getFranchises')
          /*
          sendEmail(this.getConcesionarioId.email.trim())
            .then(data => {
              this.$router.push('/concesionarios/getFranchises')
            })
            .catch(error => {
              this.$router.push('/concesionarios/getFranchises')
              console.log(error)
            })
          */
        })
        .catch(error => {
          this.disabledButton = false
          console.log(error)
          this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
          this.mensaje.color = 'warning'
          this.showAlert()
        })
    },
    /* prefcheck() {
      console.log(this.preferential, 'pref')
      if (this.preferential === true) {
        this.pref = 0
      } else {
        this.pref = 1
      }
    }, */
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    validateRegisteredPhone(phone) {
      if (this.registeredPhone['+52' + phone]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredRFC(rfc) {
      if (this.registeredRFC[rfc.trim()]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredEmail(email) {
      if (this.registeredEmail[email.trim()]) {
        return false
      } else {
        return true
      }
    },
    handleEstadoChange(estado) {
      if (estado === null) {
        this.municipios = []
        this.colonias = []
        this.codigos = []
        this.getConcesionarioId.address.city = ''
        this.getConcesionarioId.address.suburb = ''
        this.getConcesionarioId.address.postalCode = ''
      } else {
        this.data = require(`../../../services/data/${estado}.json`)
        this.colonias = []
        this.codigos = []
        this.municipios = this.data[estado]
        this.getConcesionarioId.address.city = ''
        this.getConcesionarioId.address.suburb = ''
        this.getConcesionarioId.address.postalCode = ''
      }
    },
    handleMunicipioChange(municipio) {
      if (municipio === null) {
        this.codigos = []
        this.colonias = []
        this.getConcesionarioId.address.suburb = ''
        this.getConcesionarioId.address.postalCode = ''
      } else {
        this.colonias = []
        this.codigos = this.data[this.getConcesionarioId.address.state][municipio]
        this.getConcesionarioId.address.suburb = ''
        this.getConcesionarioId.address.postalCode = ''
      }
    },
    handleCodigoChange(codigo) {
      if (codigo === null) {
        this.colonias = []
        this.getDriverById.address.suburb = ''
      } else {
        this.colonias = this.data[this.getConcesionarioId.address.state][this.getConcesionarioId.address.city][codigo]
        this.getConcesionarioId.address.suburb = ''
      }
    },
  },
  created() {
    /*
    if (this.$route.params.id != null) {
      this.$apollo.queries.getConcesionarioId.skip = false
    } else {
      */
    this.$apollo.query({ query: GET_CONCESIONARIOS, context: headers() })
      .then(({ data }) => {
        data.getConcesionarios.forEach(concesionario => {
          this.registeredRFC[concesionario.rfc] = 1
          this.registeredPhone[concesionario.phoneNumber] = 1
          this.registeredEmail[concesionario.email] = 1
        })
      })
      .catch(error => {
        console.log(error)
      })
    // }
  },
  validations: {
    getConcesionarioId: {
      name: { required },
      email: { required, email },
      phoneNumber: { phoneNumber, required },
      rfc: { required, rfc },
      address: {
        city: { required },
        state: { required },
        extNumber: { required, alphaNum },
        intNumber: { alphaNum },
        postalCode: { required, numeric },
        suburb: { required },
        street: { required },
      },
    },
  },
}
</script>
